import { useEffect, useState } from "react";

const PIPS = {
  1: [4],
  2: [0, 8],
  3: [0, 4, 8],
  4: [0, 2, 6, 8],
  5: [0, 2, 4, 6, 8],
  6: [0, 2, 3, 5, 6, 8],
};
// rotation that brings face N to the front
const ROT = { 1: [0, 0], 2: [0, -90], 3: [-90, 0], 4: [90, 0], 5: [0, 90], 6: [0, 180] };
const FACES = [
  [1, "translateZ(var(--h))"],
  [2, "rotateY(90deg) translateZ(var(--h))"],
  [3, "rotateX(90deg) translateZ(var(--h))"],
  [4, "rotateX(-90deg) translateZ(var(--h))"],
  [5, "rotateY(-90deg) translateZ(var(--h))"],
  [6, "rotateY(180deg) translateZ(var(--h))"],
];

const Face = ({ n, transform, ivory }) => (
  <div className={`dice-face ${ivory ? "ivory" : ""}`} style={{ transform }}>
    {Array.from({ length: 9 }).map((_, i) => (
      <span key={i} className={PIPS[n].includes(i) ? "dice-pip" : ""} />
    ))}
  </div>
);

export const Die = ({ value = 1, size = 80, ivory = false, spins = 0, flat = false, testId }) => {
  const [rx, ry] = ROT[value];
  const extra = spins * 360;
  const tx = flat ? 0 : -18;
  const ty = flat ? 0 : 24;
  return (
    <div className="dice-scene" style={{ width: size, height: size }} data-testid={testId}>
      <div
        className="dice-cube"
        style={{
          width: size,
          height: size,
          "--h": `${size / 2}px`,
          transform: `rotateX(${rx + tx + extra}deg) rotateY(${ry + ty + extra}deg)`,
        }}
      >
        {FACES.map(([n, tr]) => (
          <Face key={n} n={n} transform={tr} ivory={ivory} />
        ))}
      </div>
    </div>
  );
};

export const RollingPair = ({ size = 96, interval = 3200 }) => {
  const [state, setState] = useState({ a: 6, b: 5, spins: 0 });
  useEffect(() => {
    const id = setInterval(() => {
      setState((s) => ({ a: 1 + Math.floor(Math.random() * 6), b: 1 + Math.floor(Math.random() * 6), spins: s.spins + 2 }));
    }, interval);
    return () => clearInterval(id);
  }, [interval]);
  return (
    <div className="flex items-end gap-6" data-testid="hero-dice">
      <div className="floaty">
        <Die value={state.a} size={size} spins={state.spins} />
      </div>
      <div className="floaty" style={{ animationDelay: "1.2s" }}>
        <Die value={state.b} size={size * 0.82} spins={state.spins} ivory />
      </div>
    </div>
  );
};
